import * as React from 'react';

export default class TicketSubmissionPage extends React.Component<{}, {}> {

  constructor(props: {}) {
    super(props);
    window.location.replace("/submit-ticket");
  }
}
